import axios from 'axios';
const AxiosConfig = axios.create({
    // baseURL: 'https://localhost:30000', // Spring Boot 서버 주소
});

// AxiosConfig.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//         if (error.response?.status === 401 && error.response?.data?.error === 'Token has expired') {
//             // 토큰이 만료되었을 때의 처리
//             localStorage.removeItem('token'); // 만료된 토큰 제거
//             // 로그인 페이지로 리다이렉트
//             window.location.href = '/login';
//         }
//         return Promise.reject(error);
//     }
// );

AxiosConfig.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
export default AxiosConfig;